module.exports = __webpack_public_path__ + "img/d20190727_4.0bc30317.jpg";